module.exports = __webpack_public_path__ + "static/media/heart.f3e6c09e.svg";